import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { GetCampaignById } from 'services'

import { AuthContext } from '@urbanx/agx.auth.client'
import { CampaignDetailModel } from '@urbanx/agx.campaigns.client'

export const createCampaignDetailsQueryKey = (
  campaignId: string | undefined
) => ['campaign-details', campaignId]

const useSelectedCampaign = (): {
  campaign?: CampaignDetailModel
  isLoading: boolean
  isFetched: boolean
} => {
  const { campaignId } = useParams()
  const { getAuthToken } = useContext(AuthContext)
  const campaignQueryKey = createCampaignDetailsQueryKey(campaignId)

  const {
    data: campaign,
    isLoading,
    isFetched,
  } = useQuery<CampaignDetailModel | undefined>({
    queryKey: campaignQueryKey,
    queryFn: (ctx) => GetCampaignById(getAuthToken, ctx.queryKey[1] as string),
    enabled: !!campaignId,
    refetchOnMount: 'always',
    staleTime: 0,
  })

  return {
    campaign,
    isLoading,
    isFetched,
  }
}

export default useSelectedCampaign
